import { BottleTonicSkullOutlineIcon } from './BottleTonicSkullOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 24EF4783-9CDC-402E-9F8D-28CCDB50F216
 * name bottle-tonic-skull-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-tonic-skull-outline.svg
 * tags
 * - Gaming / RPG 
 * - Holiday 
 */
export const MoonshineOutlineIcon = BottleTonicSkullOutlineIcon;
export default MoonshineOutlineIcon